import { render } from "./CatalogFooter.vue?vue&type=template&id=17a4f4c1&scoped=true"
import script from "./CatalogFooter.vue?vue&type=script&lang=js"
export * from "./CatalogFooter.vue?vue&type=script&lang=js"

import "./CatalogFooter.vue?vue&type=style&index=0&id=17a4f4c1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a4f4c1"]])

export default __exports__